module.exports = __webpack_public_path__ + "static/media/agile_hat.f0985a26.png";